import { render, staticRenderFns } from "./sellers.vue?vue&type=template&id=7515bb62&scoped=true"
import script from "./sellers.vue?vue&type=script&lang=js"
export * from "./sellers.vue?vue&type=script&lang=js"
import style0 from "./sellers.vue?vue&type=style&index=0&id=7515bb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515bb62",
  null
  
)

export default component.exports